export type SbdItemCode =
  | "SBD_Q1"
  | "SBD_Q2"
  | "SBD_Q3"
  | "SBD_Q4"
  | "SBD_Q5"
  | "SBD_QT";

export type SbdLevel = "none" | "sedang" | "tinggi";

export interface SbdItem {
  code: SbdItemCode;
  no: string;
  label: string;
  skriningAwal: boolean;
}

export interface SbdOption {
  value: string;
  text: string;
}

export interface SbdKategori {
  label: string;
  color: string;
  tindakan: string;
}

export const SBD_INSTRUMEN = "sop_rsps";

export const SBD_ITEMS: SbdItem[] = [
  {
    code: "SBD_Q1",
    no: "1",
    label:
      "Dalam beberapa waktu terakhir, apakah pasien pernah berharap lebih baik mati atau tidak bangun lagi?",
    skriningAwal: true
  },
  {
    code: "SBD_Q2",
    no: "2",
    label: "Apakah pasien pernah berpikir untuk menyakiti diri sendiri?",
    skriningAwal: true
  },
  {
    code: "SBD_Q3",
    no: "3",
    label: "Apakah pasien pernah mempunyai pikiran untuk bunuh diri?",
    skriningAwal: true
  },
  {
    code: "SBD_Q4",
    no: "4",
    label: "Apakah pasien pernah mencoba bunuh diri sebelumnya?",
    skriningAwal: true
  },
  {
    code: "SBD_Q5",
    no: "5",
    label:
      "Saat ini, apakah pasien memiliki rencana, niat, atau dorongan kuat untuk bunuh diri/melukai diri sendiri?",
    skriningAwal: false
  },
  {
    code: "SBD_QT",
    no: "Tambahan",
    label:
      "Saat ini atau belakangan ini, apakah pasien pernah sengaja melukai diri sendiri walaupun tidak bermaksud mati?",
    skriningAwal: false
  }
];

export const SBD_ALASAN_PENGKAJIAN: SbdOption[] = [
  { value: "skrining_positif", text: "Skrining positif" },
  { value: "percobaan", text: "Percobaan" },
  { value: "perubahan_perilaku", text: "Perubahan perilaku" },
  { value: "lainnya", text: "Lainnya" }
];

export const SBD_TANDA_RISIKO_AKUT: SbdOption[] = [
  { value: "rencana_spesifik", text: "Rencana spesifik" },
  { value: "niat_kuat", text: "Niat kuat" },
  { value: "akses_alat", text: "Akses ke alat/sarana" },
  { value: "percobaan_baru", text: "Percobaan baru" },
  { value: "agitasi_berat", text: "Agitasi berat" },
  { value: "psikosis", text: "Psikosis" },
  { value: "intoksikasi", text: "Intoksikasi" },
  { value: "delirium", text: "Delirium" },
  { value: "tidak_aman_ditinggal", text: "Tidak aman ditinggal" }
];

export const SBD_PERILAKU_NONVERBAL: SbdOption[] = [
  { value: "gelisah", text: "Gelisah" },
  { value: "menangis_terus_menerus", text: "Menangis terus-menerus" },
  { value: "tampak_putus_asa", text: "Tampak putus asa" }
];

export const SBD_KATEGORI: Record<SbdLevel, SbdKategori> = {
  none: {
    label: "Negatif (Tidak Berisiko)",
    color: "green",
    tindakan:
      "Tidak ditemukan risiko bunuh diri atau melukai diri sendiri saat skrining. Lanjutkan pelayanan rutin dan skrining ulang bila kondisi berubah."
  },
  sedang: {
    label: "Positif Non-Akut (Risiko Sedang)",
    color: "orange",
    tindakan:
      "Pasien memerlukan pengkajian lanjutan, edukasi, rencana keselamatan, dan pertimbangan konsultasi sesuai kondisi."
  },
  tinggi: {
    label: "Positif Akut (Risiko Tinggi)",
    color: "red",
    tindakan:
      "Pasien harus segera diamankan, tidak ditinggal sendiri, dokter/DPJP diberitahu segera, dan dilakukan pengkajian lanjutan/rujukan/konsultasi emergensi."
  }
};

export function optionText(options: SbdOption[], value: string): string {
  const found = options.find(o => o.value === value);
  return found ? found.text : value;
}
